<template>
    <v-card class="pa-2 pb-3">
        <v-card-title class="headline px-3">Add Tracking</v-card-title>

        <div v-if="!showConfirmView">
            <v-card style="background-color: #5cb860" class="mt-2 mx-3">
                <v-layout row>
                    <div
                        class="pa-3 pt-4 mt-1 display-1 font-weight-light"
                        style="width: 48%; color: #fff"
                    >
                        Default Values
                    </div>
                    <v-card-actions
                        class="pb-3 my-2 mx-3"
                        style="width: 71%; background-color: #fff; border-radius: 3px;"
                    >
                        <v-layout row>
                            <v-select
                                style="width: 20%;"
                                class="mr-3 ml-4"
                                :items="getTrackTypes()"
                                label="Type"
                                v-model="trackType"
                                @change="updateTrackType"
                                hide-details
                            ></v-select>
                            <v-text-field
                                style="width: 25%;"
                                class="mr-2"
                                hide-details
                                label="Details"
                                v-model="data"
                                :type="getDataInputType(trackType)"
                                @input="updateData"
                            ></v-text-field>
                        </v-layout>
                    </v-card-actions>
                </v-layout>
            </v-card>
            <v-divider></v-divider>
            <v-card-text class="pa-2 mt-3 scroll mx-2" style="height: 500px;">
                <div
                    class="headline font-weight-regular mb-4 text-xs-center"
                    v-if="!students.length"
                >
                    Please select students
                </div>
                <div v-for="(student, index) in students" class="tracking-line">
                    <v-layout row class="mb-2 mt-0">
                        <div style="width: 40%;" class="mr-3">
                            <div class="font-weight-bold">
                                {{ student.fullName }}
                            </div>
                            <v-layout row
                                ><div class="font-weight-regular pr-1">
                                    Grade:
                                </div>
                                <div class="font-weight-light pr-2">
                                    {{ student.grade }}
                                </div>
                                <div class="font-weight-regular pr-1">
                                    Branch:
                                </div>
                                <div class="font-weight-light pr-2">
                                    {{ student.branch }}
                                </div>
                                <div class="font-weight-regular pr-1">
                                    Class:
                                </div>
                                <div class="font-weight-light ">
                                    {{ student.class }}
                                </div></v-layout
                            >
                            <v-layout row
                                ><div class="font-weight-regular pr-1">
                                    Teacher:
                                </div>
                                <div class="font-weight-light">
                                    {{ student.teacher }}
                                </div></v-layout
                            >
                        </div>
                        <v-select
                            style="width: 20%;"
                            class="mx-2 pt-4"
                            :items="getTrackTypes()"
                            label="Type"
                            v-model="student.trackType"
                            ref="trackType"
                            clearable
                        ></v-select>
                        <v-text-field
                            style="width: 25%;"
                            class="mx-2 pt-4"
                            label="Details"
                            :rules="[value => dataRule(value, student)]"
                            v-model="student.data"
                            :type="getDataInputType(student.trackType)"
                            ref="data"
                        ></v-text-field></v-layout
                    ><v-divider
                        class="mt-0 mb-2 pb-1"
                        v-if="index + 1 < students.length"
                        :key="index"
                    ></v-divider>
                </div>
            </v-card-text>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <v-btn dark color="default" @click="closeDialog()"
                    >Cancel</v-btn
                >
                <v-btn
                    :disabled="
                        !students.length || !students.some(s => s.trackType)
                    "
                    :loading="processing"
                    color="success"
                    @click="continueToConfirm()"
                >
                    Continue
                </v-btn>
            </v-card-actions>
        </div>

        <div v-else>
            <div
                class="headline font-weight-regular text-warning mb-4 text-xs-center"
            >
                Please confirm tracking details below
            </div>
            <v-card-text class="pa-2 mt-3 scroll" style="height: 500px;">
                <div
                    height="50"
                    v-for="(student, index) in students.filter(
                        s => s.trackType
                    )"
                >
                    <v-layout row class="font-weight-regular">
                        <div style="width: 40%;" class="mr-3">
                            <div class="font-weight-bold">
                                {{ student.fullName }}
                            </div>
                            <v-layout row
                                ><div class="font-weight-regular pr-1">
                                    Grade:
                                </div>
                                <div class="font-weight-light pr-2">
                                    {{ student.grade }}
                                </div>
                                <div class="font-weight-regular pr-1">
                                    Branch:
                                </div>
                                <div class="font-weight-light pr-2">
                                    {{ student.branch }}
                                </div>
                                <div class="font-weight-regular pr-1">
                                    Class:
                                </div>
                                <div class="font-weight-light ">
                                    {{ student.class }}
                                </div></v-layout
                            >
                            <v-layout row
                                ><div class="font-weight-regular pr-1">
                                    Teacher:
                                </div>
                                <div class="font-weight-light">
                                    {{ student.teacher }}
                                </div></v-layout
                            >
                        </div>
                        <div
                            style="width: 25%; text-align: right;"
                            class="mx-3 text-xs-center pt-4"
                        >
                            {{ student.trackType }}
                        </div>
                        <div
                            style="width: 20%;"
                            class="mx-3 text-xs-center pt-4 tracking-data"
                        >
                            {{ student.data }}
                        </div>
                    </v-layout>
                    <v-divider
                        class="mt-2 mb-2 pb-1"
                        v-if="index + 1 < students.length"
                        :key="index"
                    ></v-divider>
                </div>
            </v-card-text>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <v-btn dark color="default" @click="closeDialog()"
                    >Cancel</v-btn
                >
                <v-btn dark color="default" @click="showConfirmView = false"
                    >Back</v-btn
                >
                <v-btn :loading="processing" color="success" @click="save()">
                    Save Tracking
                </v-btn>
            </v-card-actions>
        </div>
    </v-card>
</template>
<script>
import moment from "moment";
import { toISOLocal, formatCurrency } from "../../utils/helpers.js";

export default {
    props: {
        students: Array,
        reloadGrid: Function,
        closeAddTrackingDialog: Function,
        getDomain: Function,
        setup: Object
    },
    components: {},
    data() {
        return {
            processing: false,
            showConfirmView: false,
            trackSetups: [],

            trackType: "",
            data: "",

            dataRule: (value, student) => {
                if (!student.trackType) return true;

                return !!value || `Required`;
            }
        };
    },
    async created() {
        await this.loadTrackSetups();
    },
    mounted() {
        window.addEventListener("keypress", this.handleEnterKey);
    },
    beforeDestroy() {
        window.removeEventListener("keypress", this.handleEnterKey);
    },
    watch: {},
    computed: {},
    methods: {
        handleEnterKey(event) {
            if (event.which == 13) {
                const nextElement = event.target.closest(".tracking-line")
                    .nextSibling;

                if (nextElement) {
                    nextElement.querySelectorAll("input")[1].focus();
                }
            }
        },
        async loadTrackSetups() {
            const trackSetups = await this.$http.get(
                this.getDomain() + "/api/setup/getTrackSetup"
            );

            this.trackSetups = trackSetups;
        },
        closeDialog() {
            this.trackType = "";
            this.data = "";
            this.showConfirmView = false;

            this.closeAddTrackingDialog();
        },
        getTrackTypes() {
            if (!this.trackSetups) return [];

            return this.trackSetups.map(g => g.description);
        },
        getTrackingCode(type) {
            if (!this.trackSetups) return "";

            const setup = this.trackSetups.find(g => g.description == type);

            return setup.code;
        },
        updateTrackType(value) {
            this.students.forEach(student => (student.trackType = value));
        },
        updateData(value) {
            this.students.forEach(student => (student.data = value));
        },
        validate() {
            const dataValidation = this.$refs.data
                .map(a => a.validate(true))
                .every(Boolean);

            return [dataValidation].every(Boolean);
        },
        getDataInputType(trackType) {
            return trackType == "Bekitsha Deposit" ? "number" : "text";
        },
        continueToConfirm() {
            if (!this.validate()) return;

            this.showConfirmView = true;
        },
        async save() {
            this.processing = true;

            const today = moment().format("YYYY-MM-DD HH:mm:ss");

            const data = this.students
                .filter(s => s.trackType)
                .map(student => {
                    return {
                        year: this.setup.currentYear,
                        enteredOn: today,
                        data: student.data,
                        studentID: student.studentID,
                        code: this.getTrackingCode(student.trackType),
                        entreredBY: this.$store.state.authentication.user,
                        updatedOn: null,
                        updatedBY: null
                    };
                });
            try {
                await this.$http.post(
                    this.getDomain() + "/api/purimStudents/postTrackingInBulk",
                    data
                );

                this.processing = false;

                this.$notify({
                    text: "Tracking Saved",
                    group: "notification",
                    type: "success"
                });

                this.closeDialog();
                this.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        }
    }
};
</script>
<style>
.scroll {
    overflow-y: auto;
}
</style>
